const places = [
  {
    name: 'Ceremonia',
    mapIcon: true,
    title: 'Templo de San Agustín',
    description: 'Calle Morelos 202, Zona Centro, 44100 Guadalajara, Jal.',
    imageUrl: process.env.PUBLIC_URL + '/assets/templo.jpg',
    time: 1500,
    description2: 'Hora: 5:00 P.M.',
    btnText: 'Maps',
    url: 'https://goo.gl/maps/xsKUwJV71Zc6KidN9',
  },
  {
    name: 'Recepción',
    mapIcon: true,
    title: 'Mansión Tequila',
    description:
      'Av. Adolfo López Mateos Sur 4028, Las Fuentes, 45070 Guadalajara, Jal.',
    imageUrl: process.env.PUBLIC_URL + '/assets/salon.jpeg',
    time: 1500,
    description2: 'Hora: 7:00 P.M.',
    btnText: 'Maps',
    url: 'https://maps.app.goo.gl/s16VXpADbuXhfwDH6',
  },
  {
    name: 'Mesa de regalos',
    mapIcon: false,
    imageUrl: process.env.PUBLIC_URL + '/assets/liverpool.png',
    btnText: 'Ir a mesa',
    time: 1500,
    url: 'https://mesaderegalos.liverpool.com.mx/milistaderegalos/51102216',
    imageUrl2: process.env.PUBLIC_URL + '/assets/amazon.png',
    btnText2: 'Ir a mesa',
    url2: 'https://www.amazon.com.mx/wedding/share/BrendaUriel',
    color: '#D21F8A'
  }
];

export default places;
